// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3F236","right":"Footer_right__1LYer","buttons":"Footer_buttons__3036Z"};